import React from 'react';

import { $ } from '../../../base/bootstrap';

export function loaderClass(loading: boolean) {
    return loading ? 'loader-visible' : 'loader-hidden';
}

export default function TableLoader({ isLoading, children }: { isLoading: boolean; children: React.ReactNode }) {
    return (
        <div className={loaderClass(isLoading)}>
            <div className="table-responsive">{children}</div>
        </div>
    );
}

export function markModelListRow(id: number) {
    $(`#model-list-row-${id}`)
        .one('animationend', function () {
            $(this).removeClass('marked-row');
        })
        .addClass('marked-row');
}
